import ButtonLoader from '@anm/components/buttons/ButtonLoader';
import SecureCard from '@anm/components/credit-card/SecureCard';
import { FC } from 'react';

import { SecurePurchaseBlockItem, SecurePurchaseBlockWrapper } from './Wrapper';

export type SecurePurchaseBlockProps = {
  sslId: string;
  isPending: boolean;
  onPurchase: () => void;
};

const SecurePurchaseBlock: FC<SecurePurchaseBlockProps> = ({
  sslId,
  isPending,
  children,
  onPurchase
}) => (
  <SecurePurchaseBlockWrapper>
    <SecurePurchaseBlockItem>
      <SecureCard sslId={sslId} />
    </SecurePurchaseBlockItem>
    <SecurePurchaseBlockItem>
      <ButtonLoader
        type="submit"
        size="big"
        color="blue"
        variant="white"
        isPending={isPending}
        onClick={onPurchase}
      >
        {children}
      </ButtonLoader>
    </SecurePurchaseBlockItem>
  </SecurePurchaseBlockWrapper>
);

export default SecurePurchaseBlock;
